
export const RESET_CHECKBOX = 'RESET_CHECKBOX';

// CONTAINER_NAME_EVENT

// COMPONENT_NAME_EVENT

export const COMPONENT = {
    DATEPICK: {
        TOGGLE: 'COMPONENT_DATEPICK_TOGGLE',
        SELECT: 'COMPONENT_DATEPICK_SELECT',
        SETDATE: 'COMPONENT_DATEPICK_SETDATE'
    },
    SCREEN_PICKER: {
        TOGGLE: 'COMPONENT_SCREEN_PICKER_TOGGLE',
        RESET: 'COMPONENT_SCREEN_PICKER_RESET',
        RECOVER_TEMPDATA: 'COMPONENT_SCREEN_PICKER_RECOVER_TEMPDATA',
        FEATURE_TAG_INIT: 'COMPONENT_SCREEN_PICKER_FEATURE_TAG_INIT'
    },
    // 区县弹框事件
    FILTER_LIST_PICKER: {
      TOGGLE: 'FILTER_LIST_PICKER_TOGGLE',
    },
    CHECKBOX: {
        RESET: 'COMPONENT_CHECKBOX_RESET',
        INIT: 'COMPONENT_CHECKBOX_INIT',
        RECOVER_TEMPDATA: 'COMPONENT_CHECKBOX_RECOVER_TEMPDATA',
        SET_TEMPDATA: 'COMPONENT_CHECKBOX_SET_TEMPDATA'
    },
    RANGE: {
        INIT: 'COMPONENT_RANGE_INIT',
        RESET: 'COMPONENT_RANGE_RESET',
        RECOVER_TEMPDATA: 'COMPONENT_RANGE_TEMPDATA',
        SET_TEMPDATA: 'COMPONENT_SET_TEMPDATA'
    },
    WHEEL_VIEW: {
        INIT: 'COMPONENT_WHEEL_VIEW_INIT',
        RESET: 'COMPONENT_WHEEL_VIEW_RESET',
        RECOVER_TEMPDATA: 'COMPONENT_WHEEL_VIEW_RECOVER_TEMPDATA',
        SET_TEMPDATA: 'COMPONENT_WHEEL_VIEW_SET_TEMPDATA'
    },
    LOADING: {
        TOGGLE: 'COMPONENT_LOADING_TOGGLE'
    },
    ALERT: {
        TOGGLE: 'COMPONENT_ALERT_TOGGLE',
        DESTROY: 'COMPONENT_ALERT_DESTROY'
    },
    TOAST: {
        POPUP: 'COMPONENT_TOAST_POPUP'
    },
    SHARETIPS: {
        TOGGLE: 'COMPONENT_SHARETIPS_TOGGLE'
    },
    ALLSERVE: {
        TOGGLE: 'COMPONENT_ALLSERVE_TOGGLE'
    },
    SIDEMENU: {
        INIT: 'COMPONENT_SIDEMENU_INIT'
    },
    SWITCH: {
        TOGGLE: 'COMPONENT_SWITCH_TOGGLE'
    },
    /**
     * 支付菜单
     */
    PAY_SHEET: {
        SHOW: 'SHOW'
    },
    /**
     * 优惠活动列表
     */
    DISCOUNT_PICKER: {
        TOGGLE: 'COMPONENT_DISCOUNT_PICKER_TOGGLE'
    },
    /**
     * 卡券和活动卡片
     */
    COUPON_ACTIVITY: {
        // TOGGLE: 'COMPONENT_COUPON_ACTIVITY_TOGGLE',
        INIT: 'COMPONENT_COUPON_ACTIVITY_INIT',//初始化选卡券状态
        SELECTED: 'COMPONENT_COUPON_ACTIVITY_SELECTED',//选中卡券或活动
        SUBMIT: 'COMPONENT_COUPON_ACTIVITY_SUBMIT',//提交选中
    },
    /**
     * 账单明细
     */
    PAY_DETAIL: {
        TOGGLE: 'COMPONENT_PAY_DETAIL_TOGGLE'
    },
    /**
     * 押金明细
     */
    GUARENT_DETAIL: {
        TOGGLE: 'COMPONENT_GUARENT_DETAIL_TOGGLE'
    },
    PRICE_DATE_PICKER: {
        SHOW: 'COMPONENT_PRICE_DATE_PICKER_SHOW',//显示
        HIDE: 'COMPONENT_PRICE_DATE_PICKER_HIDE',//隐藏
        SELECTED: 'COMPONENT_PRICE_DATE_PICKER_SELECTED'//抛出选中的日期
    },
    /**
     * 房间评价
     */
    ROOM_EVALUATION: {
        SHOW: 'COMPONENT_ROOM_EVALUATION_SHOW',
        HIDE: 'COMPONENT_ROOM_EVALUATION_HIDE'
    },
    /**
     * 口令
     */
    PASS_PHRASE: {
        TOGGLE: 'COMPONENT_PASS_PHRASE_TOGGLE',
    },
    /**
     * 导航小红点
     */
    NAV_NOTICE: {
        TOGGLE: 'COMPONENT_NAV_NOTICE_TOGGLE'
    },
    NAV:{
        TOGGLE: 'COMPONENT_NAV_TOGGLE'
    },
    // 导航条 优惠券到期提醒
    NAV_MINE_DOT: {
        TOGGLE: 'COMPONENT_NAV_MINE_DOT_TOGGLE'
    },

    COMMENT_ITEM: {
        INIT: 'COMPONENT_COMMENT_ITEM'
    },
    AGREEMENT: {
        TOGGLE: 'COMPONENT_AGREEMENT'
    },
    //订单详情页 人脸识别
    FACE_RECOGNITION:{
        TOGGLE: 'COMPONENT_FACE_RECOGNITION_TOGGLE'
    },
    //订单详情页 人脸识别
    FEED_BACK:{
        TOGGLE: 'COMPONENT_FEED_BACK_TOGGLE'
    },
    // 首页 查询窗口
    SEARCH_POPUP: {
      SHOW: 'COMPONENT_SEARCH_POPUP_SHOW',
      HIDE: 'COMPONENT_SEARCH_POPUP_HIDE'
    }
};


// WEBPACK FOOTER //
// ./src/ui-event/index.js